﻿(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Services").service("SitecoreAnalytics", [
    "API",
    "$filter",
    "DebugLogger",
    function (API, $filter, DebugLogger) {
      var exports = this;

      exports.triggerGoal = function (goalId) {
        if (!goalId) {
          return true;
        }

        var url = $filter("formatArgs")(ToyotaConsts.API.Analytics.TriggerGoal, [goalId]);
        DebugLogger.log("SitecoreAnalytics", 'url: "' + url + '"');
        var triggerGoalData = {};

        DebugLogger.log("SitecoreAnalytics", 'triggerGoal for goalId "' + goalId + '"');
        API.post(url, triggerGoalData);

        return true;
      };

      return exports;
    },
  ]);
})(window.angular, window.ToyotaConsts);
